module.exports = __webpack_public_path__ + "img/warehouse.f0cdf394.png";